import React from 'react';
import { ShieldIcon, StarIcon, CheckCircle2Icon, MessageCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const chatMessages = [{
    type: 'sent',
    text: 'Hoy soñé algo contigo... pero no sé si debería contarte 😏'
  }, {
    type: 'received',
    text: 'Jaja ahora NECESITO saber qué soñaste 👀'
  }, {
    type: 'sent',
    text: 'Me acordé de ti... y mejor cambié de tema 🙈'
  }, {
    type: 'received',
    text: '¿Por qué cambiaste de tema? Ahora no puedo dejar de pensar en eso'
  }, {
    type: 'sent',
    text: 'Tengo un plan para el viernes, pero necesito a alguien interesante...'
  }, {
    type: 'received',
    text: '¿Me estás invitando? Porque ya dije que sí 😏'
  }, {
    type: 'sent',
    text: 'Acabo de ver algo que me recordó a ti... ¿debería preocuparme? 😌'
  }, {
    type: 'received',
    text: 'Ok ahora tengo curiosidad... ¿qué fue?'
  }, {
    type: 'sent',
    text: 'No te voy a decir lo que estaba pensando... 🤭'
  }, {
    type: 'received',
    text: 'No puedes dejarme así... ¡cuéntame!'
  }, {
    type: 'sent',
    text: 'Ayer me dijeron algo sobre ti... pero mejor te cuento en persona 👀'
  }, {
    type: 'received',
    text: '¿Qué te dijeron? Necesito saberlo YA 🔥'
  }];
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-b from-dark to-[#1f1f35] overflow-hidden relative" data-id="element-112">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-113">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-rose-900/30 rounded-full blur-3xl" data-id="element-114"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-gold-900/20 rounded-full blur-3xl" data-id="element-115"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-116">
        <div className="flex flex-col items-center" data-id="element-117">
          {/* Main Content: Centered */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center space-y-6 text-center max-w-3xl" data-id="element-118">
            <div className="flex items-center space-x-1" data-id="element-119">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-120" />)}
              <span className="ml-2 text-sm font-medium text-gray-400" data-id="element-121">
                Más de 5,000 mujeres felices
              </span>
            </div>

            <h1 className="md:text-5xl lg:text-6xl font-bold text-white text-[32px]" data-id="element-122">
              Deja de enviar mensajes... <br data-id="element-123" />
              <span className="text-rose-500" data-id="element-124">HAZ que ÉL escriba primero</span>
            </h1>

            <p className="md:text-2xl font-medium text-gray-300 font-['Tiro_Gurmukhi',_serif] text-[20px]" data-id="element-125">
              Domina conversaciones <em data-id="element-126">irresistibles</em> en menos de 2 horas y
              haz que su interés crezca <strong data-id="element-127">sin perseguirlo</strong>.
            </p>

            <img src="https://cdn.magicpatterns.com/uploads/f8e3hdrMctGZKYLkD9dpmw/ChatGPT_Image_18_mar_2026,_23_24_32.png" alt="Mujer rodeada de pensamientos sobre mensajes y relaciones" className="w-full max-w-xl rounded-2xl shadow-2xl" data-id="element-128" />

            <p className="text-gray-400 text-[16px] leading-relaxed" data-id="element-129">
              Descubre <strong data-id="element-130">EXACTAMENTE</strong> qué decir en cada momento
              para despertar
              <em data-id="element-131"> deseo, intriga y conexión real</em>…{' '}
              <br className="hidden sm:block" data-id="element-132" />
              <span className="underline decoration-rose-500/50 underline-offset-4" data-id="element-133">
                sin parecer necesitada ni forzada.
              </span>
            </p>

            <div className="flex flex-wrap justify-center gap-3 py-2" data-id="element-134">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-rose-500/10 text-rose-200 text-sm font-semibold border border-rose-500/30" data-id="element-135">
                <CheckCircle2Icon className="w-4 h-4 mr-1.5" data-id="element-136" />
                [Mensajes Probados]
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-rose-500/10 text-rose-200 text-sm font-semibold border border-rose-500/30" data-id="element-137">
                <MessageCircleIcon className="w-4 h-4 mr-1.5" data-id="element-138" />
                +100 Frases
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-rose-500/10 text-rose-200 text-sm font-semibold border border-rose-500/30" data-id="element-139">
                <ShieldIcon className="w-4 h-4 mr-1.5" data-id="element-140" />
                Método Paso a Paso
              </span>
            </div>

            <div className="pt-4 flex flex-col items-center space-y-3" data-id="element-141">
              <a href="https://www.mensajesmagneticospro.com/cart/add?id=48021977792740&quantity=1" onClick={() => {
              if ((window as any).fbq) (window as any).fbq('track', 'AddToCart');
            }} className="w-full sm:w-auto text-center bg-rose-700 hover:bg-rose-800 text-white font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse-slow text-lg" data-id="element-142">
                👉 QUIERO QUE ÉL ME BUSQUE AHORA
              </a>
              <div className="flex items-center text-sm text-gray-400 font-medium" data-id="element-143">
                <span className="flex items-center" data-id="element-144">
                  <ShieldIcon className="w-4 h-4 mr-1 text-green-500" data-id="element-145" /> Acceso
                  inmediato
                </span>
                <span className="mx-2" data-id="element-146">•</span>
                <span data-id="element-147">Pago único</span>
                <span className="mx-2" data-id="element-148">•</span>
                <span data-id="element-149">Garantía 7 días</span>
              </div>
            </div>
          </motion.div>

          {/* Phone Visual: Centered below */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mt-12 flex justify-center" data-id="element-150">
            <div className="relative w-[280px] md:w-[320px] h-[500px] md:h-[560px]" data-id="element-151">
              {/* Subtle decorative glow */}
              <div className="absolute -inset-4 bg-rose-500/20 rounded-3xl blur-2xl -z-10" data-id="element-152"></div>

              {/* Phone Frame */}
              <div className="relative w-full h-full bg-[#1a1a2e] border-[6px] border-gray-800 rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col" data-id="element-153">
                {/* Top Notch */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-5 bg-gray-800 rounded-b-xl z-20" data-id="element-154"></div>

                {/* Top Gradient Fade */}
                <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[#1a1a2e] to-transparent z-10 pointer-events-none" data-id="element-155"></div>

                {/* Scrolling Messages Container */}
                <div className="flex-1 overflow-hidden relative pt-12 pb-4 px-4" data-id="element-156">
                  <div className="animate-scroll-messages flex flex-col space-y-4" data-id="element-157">
                    {/* First set of messages */}
                    {chatMessages.map((msg, idx) => <div key={`msg-1-${idx}`} className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm shadow-sm ${msg.type === 'sent' ? 'ml-auto bg-rose-700 text-white rounded-tr-sm' : 'mr-auto bg-white/10 text-white rounded-tl-sm border border-white/5'}`} data-id="element-158">
                        {msg.text}
                      </div>)}
                    {/* Duplicated set for seamless infinite scroll */}
                    {chatMessages.map((msg, idx) => <div key={`msg-2-${idx}`} className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm shadow-sm ${msg.type === 'sent' ? 'ml-auto bg-rose-700 text-white rounded-tr-sm' : 'mr-auto bg-white/10 text-white rounded-tl-sm border border-white/5'}`} data-id="element-159">
                        {msg.text}
                      </div>)}
                  </div>
                </div>

                {/* Bottom Gradient Fade */}
                <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#1a1a2e] to-transparent z-10 pointer-events-none" data-id="element-160"></div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 text-center border-t border-white/10 pt-8" data-id="element-161">
          <div className="flex flex-col items-center" data-id="element-162">
            <span className="text-4xl font-heading font-bold text-gold-400 mb-2" data-id="element-163">
              +100
            </span>
            <span className="text-gray-400 font-medium uppercase tracking-wider text-sm" data-id="element-164">
              Mensajes Listos pdf
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-165">
            <span className="text-4xl font-heading font-bold text-gold-400 mb-2" data-id="element-166">
              3
            </span>
            <span className="text-gray-400 font-medium uppercase tracking-wider text-sm" data-id="element-167">
              Pasos Probados
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-168">
            <span className="text-4xl font-heading font-bold text-gold-400 mb-2" data-id="element-169">
              +20 videos
            </span>
            <span className="text-gray-400 font-medium uppercase tracking-wider text-sm" data-id="element-170">
              paso a paso
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}